const $ = jQuery;

function setupMobileNav() {
    const $body = $('body');
    const $nav = $('#mobile-nav');
    const $header = $('#header');
    const $adminBar = $('#wpadminbar');

    const $toggleBtn = $('#ocm');

    let safetyTimer;
    let wasPurple = false;

    if (!$nav.length || !$toggleBtn.length) return;

    const adjustNavPosition = () => {
        const adminBarHeight = $adminBar.length ? $adminBar.outerHeight() : 0;
        const headerHeight = $header.length ? $header.outerHeight() : 0;

        const totalTop = adminBarHeight + headerHeight - 1;

        $nav.css({
            'top': totalTop + 'px',
            'height': `calc(100vh - ${totalTop}px)`
        });
    };

    const restoreBorder = () => {
        if (!$body.hasClass('mobile-nav-open')) {
            $header.addClass('!no-transition').css('transition', 'none');

            $header.css('border-bottom-color', '');

            void $header[0].offsetWidth;

            $header.css('transition', '');
            $header.removeClass('!no-transition');
        }
    };

    const toggleMenu = () => {
        const isCurrentlyOpen = $body.hasClass('mobile-nav-open');
        const $panel = $nav.find('.mobile-nav-panel');

        if (isCurrentlyOpen) {
            $body.removeClass('mobile-nav-open');
            $toggleBtn.attr('aria-expanded', 'false');

            $header.addClass('bg-fxd-purple text-white');

            $panel.one('transitionend', function(e) {
                if (e.target !== this) return;
                clearTimeout(safetyTimer);
                restoreBorder();

                if (!wasPurple) {
                    $header.removeClass('bg-fxd-purple text-white');
                }
            });

            clearTimeout(safetyTimer);
            safetyTimer = setTimeout(() => {
                restoreBorder();
                if (!wasPurple) {
                    $header.removeClass('bg-fxd-purple text-white');
                }
            }, 750);

        } else {
            wasPurple = $header.hasClass('bg-fxd-purple');

            $body.addClass('mobile-nav-open');
            $toggleBtn.attr('aria-expanded', 'true');

            $panel.off('transitionend');
            clearTimeout(safetyTimer);

            $header.removeClass('bg-fxd-purple text-white');
            $header.css('border-bottom-color', 'transparent');
        }
    };

    const forceClose = () => {
        $body.removeClass('mobile-nav-open');
        $toggleBtn.attr('aria-expanded', 'false');

        $nav.find('.mobile-nav-panel').off('transitionend');
        clearTimeout(safetyTimer);

        $header.css('border-bottom-color', '');
        $header.removeClass('bg-fxd-purple text-white');
    };

    adjustNavPosition();

    $toggleBtn.off('click.mobileNav').on('click.mobileNav', function(e) {
        e.preventDefault();
        toggleMenu();
    });

    $(window).on('resize', function() {
        adjustNavPosition();
        if ($(window).width() > 1279) {
            forceClose();
        }
    });
}

export default {
    init() {
        setupMobileNav();
    }
};
